import React, { useState } from 'react';
import { CheckCircle, Upload } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { updateSiteSettings } from '../../utils/api';
import { toast } from 'sonner';

export const AdminSettings = ({ siteSettings: initialSettings, loadData }) => {
  const [settings, setSettings] = useState(initialSettings);

  // Sync if parent data changes
  React.useEffect(() => {
    setSettings(initialSettings);
  }, [initialSettings]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-testid="settings-tab-content">
      <div className="bg-white rounded-xl p-8 shadow-sm border border-slate-200">
        <h2 className="text-2xl font-bold text-slate-900 mb-6">Office Details</h2>
        <div className="space-y-4">
          <div><Label htmlFor="office-address">Office Address</Label>
            <Textarea id="office-address" value={settings.office_address} onChange={(e) => setSettings({...settings, office_address: e.target.value})} placeholder="Enter office address..." className="mt-2" rows={3} /></div>
          <div><Label htmlFor="office-hours">Office Hours</Label>
            <Input id="office-hours" value={settings.office_hours} onChange={(e) => setSettings({...settings, office_hours: e.target.value})} placeholder="e.g., Mon-Fri: 9AM - 6PM" className="mt-2" /></div>
          <div><Label htmlFor="office-phone">Phone Number</Label>
            <Input id="office-phone" value={settings.office_phone} onChange={(e) => setSettings({...settings, office_phone: e.target.value})} placeholder="e.g., +63 2 1234 5678" className="mt-2" /></div>
          <div><Label htmlFor="office-email">Email Address</Label>
            <Input id="office-email" type="email" value={settings.office_email} onChange={(e) => setSettings({...settings, office_email: e.target.value})} placeholder="e.g., contact@lexdoright.com" className="mt-2" /></div>
        </div>
      </div>

      <div className="bg-white rounded-xl p-8 shadow-sm border border-slate-200">
        <h2 className="text-2xl font-bold text-slate-900 mb-6">Social Media Links</h2>
        <div className="space-y-4">
          {[
            { id: 'facebook_url', label: 'Facebook', placeholder: 'https://facebook.com/...' },
            { id: 'instagram_url', label: 'Instagram', placeholder: 'https://instagram.com/...' },
            { id: 'tiktok_url', label: 'TikTok', placeholder: 'https://tiktok.com/@...' },
            { id: 'twitter_url', label: 'Twitter/X', placeholder: 'https://twitter.com/...' },
            { id: 'linkedin_url', label: 'LinkedIn', placeholder: 'https://linkedin.com/company/...' },
            { id: 'youtube_url', label: 'YouTube', placeholder: 'https://youtube.com/@...' },
          ].map(field => (
            <div key={field.id}>
              <Label htmlFor={field.id}>{field.label}</Label>
              <Input id={field.id} value={settings[field.id]} onChange={(e) => setSettings({...settings, [field.id]: e.target.value})} placeholder={field.placeholder} className="mt-2" />
            </div>
          ))}
        </div>
      </div>

      <div className="lg:col-span-2">
        <Button className="w-full bg-[#8B1818] hover:bg-[#701313] text-white py-3"
          onClick={async () => {
            try {
              await updateSiteSettings(settings);
              toast.success('Settings saved successfully!');
              loadData();
            } catch (err) {
              toast.error('Failed to save settings');
            }
          }}>
          <CheckCircle className="mr-2 h-5 w-5" />
          Save All Settings
        </Button>
      </div>
    </div>
  );
};
